import NewClaimIcon from 'assets/images/home/new-claim.svg';
import { StyledTitle } from 'components/StyledTitle';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TitleWrapper = styled.div`
  grid-column: 1/3;
  grid-template-columns: fit-content(84px) auto;
  display: grid;
  column-gap: 10px;
  align-items: center;
`;

const ImageWrapper = styled.img`
  grid-row: 1 / span 2;
`;

const DescriptionTitle = styled(StyledTitle)`
  color: rgba(0, 0, 0, 0.45) !important;
  font-weight: 400 !important;
`;
export const PreClaimTitle = () => {
  const { t } = useTranslation();
  return (
    <TitleWrapper>
      <ImageWrapper style={{ gridRow: 1 / 2 }} src={NewClaimIcon} alt="new claim" />
      <StyledTitle level={2}>{t('claims.preClaim')}</StyledTitle>
      <DescriptionTitle level={5}>{t('preAuthRequest.description')}</DescriptionTitle>
    </TitleWrapper>
  );
};
